<template>
  <div class="formgroup">
    <drag-modal :visible="visible" @cancel="visible = false" title='表单导出' width='400px'>
      <ul class="uls">
        <li v-if='$common.AUTH("export:fqxxb")'>
          分期信息表<a-button size="small" icon="download" style="height:28px;" @click="out(1)">导出</a-button>
        </li>
        <li v-if='$common.AUTH("export:hkxxb")'>
          案款信息表<a-button size="small" icon="download" style="height:28px;" @click="out(2)">导出</a-button>
        </li>
        <li v-if='$common.AUTH("export:lsjdb")'>
          历史进度表<a-button size="small" icon="download" style="height:28px;" @click="out(4, true)">导出</a-button>
        </li>
        <li v-if='$common.AUTH("export:cpwsb")'>
          裁判文书表<a-button size="small" icon="download" style="height:28px;" @click="out(5)">导出</a-button>
        </li>
        <li v-if='$common.AUTH("export:ssxxzb")'>
          案件信息总表 <a-button size="small" icon="download" style="height:28px;" @click="out(0)">导出</a-button>
        </li>
        <li v-if='$common.AUTH("export:cpjladlrb")'>
          传票及立案代理人表<a-button size="small" icon="download" style="height:28px;" @click="out(6)">导出</a-button>
        </li>
        <li v-if='$common.AUTH("export:ssdlfyjnjtfb")'>
          案件代理费用缴纳及退费表<a-button size="small" icon="download" style="height:28px;" @click="out(7)">导出</a-button>
        </li>
      </ul>
    </drag-modal>
    <a-row class="row" :gutter="20">
      <a-col :span='5' class="flex">
        <label>委托类型：</label>
        <a-select placeholder="请选择委托类型" class="select" allowClear>
          <a-select-option :value="1">委托代理</a-select-option>
          <a-select-option :value="2">委托管理</a-select-option>
        </a-select>
      </a-col>

      <a-col :span='6' class="flex">
        <label>原告：</label>
        <a-select class="select" v-model="form.accuser_id" placeholder="请选择原告" mode="multiple" :maxTagCount='1'
          :maxTagTextLength='6' @change="ckAcc" allowClear :filter-option="$common.filterOption">
          <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id" :title="item.title">{{
            item.title }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span='6' class="flex">
        <label>管辖法院：</label>
        <a-select class="select" v-model="form.court_id" placeholder="请选择管辖法院" mode="multiple" :maxTagCount='1'
          :maxTagTextLength='6' @search="handleSearch" :default-active-first-option="false" :show-arrow="false"
          :filter-option="false" :not-found-content="null" allowClear>
          <a-select-option v-for="item in courtList" :key="item.id" :value="item.id" :title="item.title">{{ item.title
          }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="7" class="flex">
        <label>录入日期：</label>
        <!-- <a-range-picker v-model='time' valueFormat="YYYY-MM-DD" @change="PickTime" /> -->
        <timePick @PickTime="PickTime" ref="timePicker"></timePick>
      </a-col>
    </a-row>
    <a-row class="row" :gutter="20">
      <!-- <a-col :span="5" class="flex">
        <label>金融机构：</label>
        <a-select  class="select" v-model="form.bank_id" placeholder="请选择"  :maxTagCount='1' :maxTagTextLength='5' :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" allowClear>
          <a-select-option v-for="item in bank" :key="item.title" :value="item.id">{{ item.title }}</a-select-option>
        </a-select>
      </a-col> -->
      <!-- <a-col :span="7" class="flex">
        <label>开庭时间：</label>
        <timePick @PickTime="PickOpen"></timePick>
      </a-col> -->
      <a-col :span='5' class="flex">
        <label>案件类型：</label>
        <a-select v-model="form.cause_type" placeholder="请选择案件类型" class="select" allowClear>
          <a-select-option :value="1">诉讼</a-select-option>
          <a-select-option :value="2">仲裁</a-select-option>
          <a-select-option :value="3" disabled>公证</a-select-option>
          <a-select-option :value="4" disabled>调解</a-select-option>
        </a-select>
      </a-col>
      <a-col :span="8" class="flex">
        <a-button icon="search" style="height:32px;" @click='search()'>查询</a-button>
        <a-button style="height:32px;margin-left:20px;" @click='reset'>重置</a-button>
        <a-button icon="upload" style="height:32px;margin-left:20px;" @click="out(0)"
          v-if='$common.AUTH("export:ssxxzb")'>导出</a-button>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { getAccuserAll, reasonList } from '@/server/api'
import { getDirectory, bankList } from "@/server/directory"
import { mapGetters } from 'vuex'
import { exportForm } from '@/assets/js/unit'
export default {
  data() {
    return {
      visible: false,
      cause_reason: [],  //案由
      accuserList: [],
      courtList: [],
      bank: [],
      form: {
        cause_type: undefined,
        bank_id: '',
        reason_id: [],
        accuser_id: [],
        debtor_stime: '',
        car_type_id: undefined,
        debtor_etime: '',
        // open_stime: '',
        // open_etime: '',
        court_id: [],
        ja_state: undefined,
        is_same_accuser: undefined,
        cause_status: undefined,
        cause_step: undefined,
        is_role_exact: undefined,
        team_id: '',
        cause_is_complete: undefined,
        loan_status: []
      }
    }
  },
  computed: {
    ...mapGetters([
      'APIKEY'
    ]),
    teamList() {
      return this.form.accuser_id.length > 1 || this.form.accuser_id.length == 0 ? [] : this.accuserList.find(ele => {
        return ele.id === this.form.accuser_id[0]
      }).team
    }
  },
  created() {
    bankList({ limit: 100 }).then(e => {
      this.bank = e.list
    })
    reasonList().then(e => {
      this.cause_reason = e.list
    })
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
    this.handleSearch('')
  },
  methods: {
    handleSearch(val) {
      getDirectory({ limit: 100, title: val }).then((res) => {
        this.courtList = res.list
      })
    },
    ckAcc(val) {
      if (val.length > 1 || val.length == 0) {
        this.form.team_id = ''
      }
    },
    PickTime(e) {
      if ("stime" in e) {
        this.form.debtor_stime = e.stime
      }
      else {
        this.form.debtor_etime = e.etime
      }
    },
    PickOpen(e) {
      if ("stime" in e) {
        this.form.open_stime = e.stime
      }
      else {
        this.form.open_etime = e.etime
      }
    },
    ckStatus(e) {
      if (e.length > 1) {
        this.form.team_id = ''
      }
    },
    search() {
      this.$emit('search', this.form)
    },
    reset() {
      this.form.limit = 10
      this.form.page = 1
      this.form.cause_type = ''
      this.form.accuser_id = []
      this.form.court_id = []
      this.form.debtor_stime = ''
      this.form.debtor_etime = ''
      this.$refs.timePicker.clearTime()
      this.search()
    },
    out(type) {
      if (this.form.debtor_stime && this.form.debtor_etime) {
        const form = JSON.parse(JSON.stringify(this.form));
        exportForm(type, form)
      } else {
        this.$message.error('请先选择时间再执行导出');
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('@/assets/css/search.less');

.uls {
  li {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
  }
}
</style>